import { handleService } from "./common";

export default {
  //门禁设备
  GetAControlTable(data) {
    let url = "/api/Device/GetDoorEquListByPgae";
    // debugger
    return handleService(url, data);
  },
  //门禁设备
  GetHandheldEquListByPgae(data) {
    let url = "/api/Device/GetHandheldEquListByPgae";
    // debugger
    return handleService(url, data);
  },

  //获取门禁设备详细数据
  GetInfo(data) {
    let url = "/api/Device/GetDoorEquInfo";
    // debugger
    return handleService(url, data);
  },
  // 获取手持机详情
  GetHandheldEquInfo(data) {
    let url = "/api/Device/GetHandheldEquInfo";
    // debugger
    return handleService(url, data);
  },
  // 故障状态查询
  GetStatus(data) {
    console.log(data);
  },
  // 修改门禁设备
  UpdateDoorEqu(data) {
    let url = "/api/Device/UpdateDoorEqu";
    // debugger
    return handleService(url, data, "POST");
  },
  // 修改手持机
  UpdateHandheldEqu(data) {
    let url = "/api/Device/UpdateHandheldEqu";
    // debugger
    return handleService(url, data, "POST");
  },
  // 获取门禁设备详细数据
  GetDoorEquInfo(data) {
    let url = "/api/Device/GetDoorEquInfo";
    // debugger
    return handleService(url, data);
  },
  //   // 获取架构区域列表-所属区域
  //   GetDoorEquListByPgae (data) {
  //     let url = '/api/Device/GetDoorEquListByPgae'
  //     // debugger
  //     return handleService(url, data)
  //   },
  // 获取行政区域列表
  GetAreaCode(data) {
    let url = "/api/Device/GetAreaCode";
    // debugger
    return handleService(url, data);
  },
  // 获取区域类型列表
  GetRegionType(data) {
    let url = "/api/Device/GetRegionType";
    // debugger
    return handleService(url, data);
  },
  // 获取场景路由列表
  GetScenes(data) {
    let url = "/api/Device/GetScenes";
    // debugger
    return handleService(url, data);
  },
  //修改延迟检测地址
  SettingDelayDetection(data) {
    let url = "/api/Device/SettingDelayDetection";
    // debugger
    return handleService(url, data, "POST");
  },
  //获取延迟检测地址
  GetDelayDetection(data) {
    let url = "/api/Device/GetDelayDetection";
    // debugger
    return handleService(url, data, "POST");
  },
  //延迟检测
  DelayDetection(data) {
    let url = "/api/Device/DelayDetection";
    // debugger
    return handleService(url, data);
  },
  //获取日志
  GetLog(data) {
    let url = "/api/Device/GetLog";
    return handleService(url, data, "POST");
  },
  //测温模式切换
  UpdateTempMode(data) {
    let url = "/api/Device/UpdateTempMode";
    return handleService(url, data, "POST");
  }
};
